import React, { useEffect } from "react"
import { X } from "react-feather"
import { formatSeminarSchedule } from "./PastSeminarCard"

export const PastSeminarModal = ({ seminar, onClose }) => {
    useEffect(() => {
        if (!seminar) return

        const previousOverflow = document.body.style.overflow
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                onClose()
            }
        }

        document.body.style.overflow = "hidden"
        document.addEventListener("keydown", handleKeyDown)

        return () => {
            document.body.style.overflow = previousOverflow
            document.removeEventListener("keydown", handleKeyDown)
        }
    }, [seminar, onClose])

    if (!seminar) return null

    const scheduleText = formatSeminarSchedule(seminar)
    const hasKeyTopics = Boolean(
        seminar.keyTopics &&
        seminar.keyTopics.replace(/<[^>]+>/g, "").trim() &&
        seminar.keyTopics.trim() !== "-"
    )
    const flyerImage =
        seminar.sidePhotoPath ||
        seminar.sidePicView ||
        seminar.seminarPhotoPath ||
        seminar.seminarPicView ||
        "/Static/Assets/Img/Seminar_Img.jpeg"

    return (
        <div
            className="modal fade show d-block"
            tabIndex="-1"
            role="dialog"
            aria-modal="true"
            style={{
                backgroundColor: "rgba(8, 26, 39, 0.85)",
                zIndex: 100005,
                position: "fixed",
                inset: 0,
                overflowY: "auto",
                padding: "20px 10px",
            }}
            onClick={onClose}
        >
            <div
                className="modal-dialog modal-dialog-centered modal-xl"
                role="document"
                onClick={(e) => e.stopPropagation()}
                style={{ maxWidth: "1120px", width: "95%", margin: "auto" }}
            >
                <div
                    className="modal-content border-0 shadow-lg position-relative"
                    style={{
                        borderRadius: "16px",
                        backgroundColor: "#ffffff",
                        maxHeight: "90vh",
                        display: "flex",
                        flexDirection: "column",
                        overflow: "hidden",
                    }}
                >
                    {/* Top Header Bar */}
                    <div
                        className="d-flex align-items-center justify-content-between px-3 px-md-4 py-2 text-white"
                        style={{
                            backgroundColor: "#102b3c",
                            borderTopLeftRadius: "16px",
                            borderTopRightRadius: "16px",
                            flexShrink: 0,
                        }}
                    >
                        <span className="fw-semibold" style={{ fontSize: "15px", color: "#fff" }}>
                            Milso Insurance Learning and Sharing Online - Past Seminar
                        </span>
                        <button
                            type="button"
                            onClick={onClose}
                            className="btn btn-sm text-white p-0 d-flex align-items-center justify-content-center"
                            style={{
                                width: "28px",
                                height: "28px",
                                border: "1px solid rgba(255,255,255,0.3)",
                                borderRadius: "4px",
                                backgroundColor: "transparent",
                                lineHeight: 1,
                                cursor: "pointer",
                            }}
                            aria-label="Close"
                        >
                            <X size={16} />
                        </button>
                    </div>

                    {/* Modal Body: Two-column pattern design matching screenshot */}
                    <div className="modal-body p-0" style={{ overflowY: "auto", flex: 1 }}>
                        <div className="row g-0 align-items-stretch" style={{ minHeight: "100%" }}>
                            {/* Left Column: Details */}
                            <div
                                className="col-12 col-lg-7 p-4 p-lg-5 d-flex flex-column justify-content-between"
                                style={{ backgroundColor: "#ffffff" }}
                            >
                                <div>
                                    <span
                                        className="badge rounded-pill px-3 py-2 mb-3"
                                        style={{
                                            backgroundColor: "#cd9e53",
                                            color: "#16374e",
                                            fontWeight: "600",
                                            fontSize: "13px",
                                        }}
                                    >
                                        Past seminar
                                    </span>

                                    <h2
                                        className="fw-bold mb-3"
                                        style={{
                                            color: "#16374e",
                                            fontSize: "1.75rem",
                                            lineHeight: "1.3",
                                        }}
                                    >
                                        {seminar.title}
                                    </h2>

                                    <div className="mb-3">
                                        {seminar.subTitle && (
                                            <span
                                                className="d-block mb-1 text-uppercase fw-semibold"
                                                style={{
                                                    color: "#514d4d",
                                                    letterSpacing: "0.5px",
                                                    fontSize: "0.95rem",
                                                }}
                                            >
                                                {seminar.subTitle}
                                            </span>
                                        )}
                                        {scheduleText && (
                                            <span className="fw-bold text-dark d-block">
                                                {scheduleText}
                                            </span>
                                        )}
                                    </div>

                                    {seminar.description && (
                                        <div
                                            className="mb-4"
                                            style={{
                                                color: "#333",
                                                textAlign: "justify",
                                                lineHeight: "1.6",
                                            }}
                                        >
                                            {/<[a-z][\s\S]*>/i.test(seminar.description) ? (
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: seminar.description,
                                                    }}
                                                />
                                            ) : (
                                                <p className="mb-0">{seminar.description}</p>
                                            )}
                                        </div>
                                    )}

                                    {hasKeyTopics && (
                                        <>
                                            <h3
                                                className="h5 fw-bold mt-4 mb-3"
                                                style={{ color: "#16374e" }}
                                            >
                                                Key topics
                                            </h3>

                                            {/<[a-z][\s\S]*>/i.test(seminar.keyTopics) ? (
                                                <div
                                                    className="mb-4"
                                                    dangerouslySetInnerHTML={{
                                                        __html: seminar.keyTopics,
                                                    }}
                                                />
                                            ) : (
                                                <ul
                                                    className="mb-4 ps-4"
                                                    style={{ color: "#333", lineHeight: "1.7" }}
                                                >
                                                    {seminar.keyTopics
                                                        .split(/[\r\n]+/)
                                                        .map((t) => t.trim())
                                                        .filter(Boolean)
                                                        .map((topic, index) => (
                                                            <li key={index} className="pe-3 mb-1">
                                                                {topic}
                                                            </li>
                                                        ))}
                                                </ul>
                                            )}
                                        </>
                                    )}
                                </div>

                                {/* Footer Action Buttons */}
                                <div className="mt-4 pt-3 border-top d-flex flex-wrap gap-2 align-items-center">
                                    {seminar.meetingLink && (
                                        <a
                                            className="btn fw-semibold px-4 py-2"
                                            href={seminar.meetingLink}
                                            target="_blank"
                                            rel="noreferrer"
                                            style={{
                                                backgroundColor: "#cd9e53",
                                                color: "#16374e",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            View Recording
                                        </a>
                                    )}
                                    {seminar.registerLink && (
                                        <a
                                            className="btn fw-semibold px-4 py-2"
                                            href={seminar.registerLink}
                                            target="_blank"
                                            rel="noreferrer"
                                            style={{
                                                backgroundColor: "#16374e",
                                                color: "#fff",
                                            }}
                                        >
                                            Event Info
                                        </a>
                                    )}
                                    <button
                                        type="button"
                                        className="btn btn-outline-secondary fw-semibold px-4 py-2 ms-auto"
                                        onClick={onClose}
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>

                            {/* Right Column: Dark navy background with Flyer Poster */}
                            <div
                                className="col-12 col-lg-5 d-flex align-items-center justify-content-center p-3 p-lg-4"
                                style={{
                                    backgroundColor: "#16374e",
                                    minHeight: "360px",
                                }}
                            >
                                <img
                                    src={flyerImage}
                                    alt={seminar.title || "Past seminar announcement"}
                                    onError={(e) => {
                                        e.currentTarget.onerror = null
                                        e.currentTarget.src = "/Static/Assets/Img/Seminar_Img.jpeg"
                                    }}
                                    className="img-fluid rounded"
                                    style={{
                                        width: "100%",
                                        maxHeight: "580px",
                                        objectFit: "contain",
                                        boxShadow: "8px 8px #cd9e53",
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default PastSeminarModal
